// extracted by mini-css-extract-plugin
export default {"card":"ClientReferenceGuideCard_card__tdp5t","buttons":"ClientReferenceGuideCard_buttons__vOgFs","progress":"ClientReferenceGuideCard_progress__OP9JO"};